/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".completed-certification-test-item[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between}.test-list-item[_ngcontent-%COMP%]{font-family:Raleway,sans-serif}.form-row[_ngcontent-%COMP%]{flex-wrap:unset}"];
export { styles as styles };
